<template>
  <div class="flex gept_main_color font-black mb-3 text-lg md:text-2xl">
    <p class="mr-2 whitespace-no-wrap hidden md:block">問題</p>
    <div class="flex items-center flex-wrap" v-for="(item, index) in questionData.Questions" :key="index">
      <div class="flex items-center">
        <div class="relative md:mx-1">
          <p class="gept_main_color6" :class="{ 'active': index === actionIdx }">{{ index + 1  }}</p>
          <div class="absolute question_order_check" v-if="ERS_arr[index]">
            <img src="@/assets/image/gept/question_order_check.png" class="object-contain">
          </div>
        </div>
        <div class="flex items-center mx-2" v-if="index < questionData.Questions.length - 1">
          <img src="@/assets/image/gept/question_order_line.png" class="object-contain md:inline-block hidden">
          <img src="@/assets/image/gept/question_order_lineM.png" class="object-contain inline-block md:hidden">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'question_order',
    props: {
      actionIdx: {
        type: Number,
        default: 0
      },
      questionData: {
        type: Object
      },
      ERS_arr: {
        type: Array
      }
    },
    data () {
      return {
      }
    },

    computed: {
    },
    mounted () {
    },
    methods: {
      isEmpty (obj) {
        return Object.keys(obj).length === 0
      }
    }
  }
</script>

<style lang="scss" scoped>
.question_order_check {
  top: 30%;
  right: -50%;
}
.active {
  color: #145F7F;
}
</style>
